import * as React from "react";
import { useQuery } from "@grandvisionhq/graphql";
import { GET_TOPIC_LIST } from "../../operations/queries/operations/queries/get-topic-list.js";
const useTopicList = () => {
  const { data } = useQuery(GET_TOPIC_LIST);
  const [topicList, setTopicList] = React.useState({});
  React.useEffect(() => {
    if (data?.getTopicList) {
      const list = data.getTopicList.reduce((list2, topic) => {
        if (!topic) {
          return list2;
        }
        list2[topic.label] = topic;
        return list2;
      }, {});
      setTopicList(list);
    }
  }, [data]);
  return topicList;
};
export {
  useTopicList
};
//# sourceMappingURL=hooks.js.map
